import { api } from '@/shared/lib/api'
import { useQuery } from '@tanstack/react-query'
import { DataTableSorting } from '@workspace/ui/components/DataTable.utils'

const useGetMasterTypeCatalog = ({
    masterTypeId = '',
    page = 1,
    pageSize = 10,
    q = '',
    sorting,
    enabled = true,
}: {
    masterTypeId?: string
    page?: number
    pageSize?: number
    q?: string
    sorting?: DataTableSorting | null
    enabled?: boolean
} = {}) => {
    const { data, isLoading, isFetching } = useQuery({
        queryKey: ['masterdata-masterTypeCatalog', masterTypeId, page, pageSize, q, sorting],
        queryFn: () =>
            api.masterType.listCatalog({
                masterTypeId,
                page,
                take: pageSize,
                q: q || undefined,
                order: sorting?.sortDirection?.toUpperCase() as 'ASC' | 'DESC',
                orderBy: sorting?.sortBy,
            }),
        enabled: !!masterTypeId && enabled,
        staleTime: 10000,
    })

    return {
        data,
        isLoading,
        isFetching,
    }
}

export default useGetMasterTypeCatalog
